// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const shedinja: PokeData = {
  "id": 292,
  "name": "shedinja",
  "height": 8,
  "weight": 12,
  "base_experience": 83,
  "types": [
    PokeType.BUG,
    PokeType.GHOST
  ],
  "api_moves": [
    "scratch",
    "sand-attack",
    "absorb",
    "dig",
    "harden",
    "confuse-ray",
    "leech-life",
    "fury-swipes",
    "mind-reader",
    "spite",
    "mud-slap",
    "false-swipe",
    "metal-claw",
    "shadow-ball",
    "grudge",
    "heal-block",
    "shadow-claw",
    "shadow-sneak",
    "phantom-force"
  ],
  "moves": [
    "scratch",
    "confuse-ray",
    "mud-slap",
    "metal-claw",
    "shadow-ball",
    "shadow-sneak",
    "phantom-force",
    "signal-spam",
    "infest",
    "soul-sacrifice",
    "pounce",
    "string-shot",
    "spectral-snatch"
  ],
  "evolution_chain": {
    "id": 144,
    "item": null,
    "species": [
      {
        "name": "nincada",
        "order": 316,
        "types": [
          PokeType.BUG,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ninjask",
        "order": 317,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 290,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "shedinja",
        "order": 318,
        "types": [
          PokeType.BUG,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 290,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.SHED
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 39,
    "speed": 80,
    "ability_power": 180
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
